import React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabelProps,
  InputBaseComponentProps,
  Checkbox,
  useTheme,
  Typography,
  FormControlLabel,
} from "@mui/material";

const SingleCheckboxCst: React.FC<
  InputLabelProps &
    InputBaseComponentProps & {
      testIdPrefix?: string;
      ariaLabelOverride?: string;
    }
> = ({
  id,
  label,
  value,
  onChange,
  customWidth,
  error = false,
  errorMessage = "",
  required = false,
  disabled,
  sx,
  testIdPrefix,
  ariaLabelOverride,
}) => {
  const theme = useTheme();

  const inputId = testIdPrefix ? `${testIdPrefix}-toggle` : id;
  const inputTestId = testIdPrefix
    ? `${testIdPrefix.replace(/-[^-]+$/, "")}-toggle-switch`
    : undefined;
  const labelId = testIdPrefix ? `${testIdPrefix}-label` : undefined;
  const labelTestId = testIdPrefix ? `${testIdPrefix}-label` : undefined;

  return (
    <FormControl
      error={error}
      size={"small"}
      required={required}
      sx={{
        minWidth: "200px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: customWidth ? customWidth : "auto",
        color: disabled === true ? theme.palette.action.disabled : "",
        ...sx,
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            id={inputId}
            checked={value || false}
            onChange={onChange}
            disabled={disabled}
            inputProps={
              {
                ...(inputTestId ? { "data-testid": inputTestId } : {}),
                ...(ariaLabelOverride
                  ? { "aria-label": ariaLabelOverride }
                  : {}),
              } as any
            }
          />
        }
        label={label}
        slotProps={
          labelTestId
            ? {
                typography: {
                  id: labelId,
                  "data-testid": labelTestId,
                } as any,
              }
            : undefined
        }
      />
      <FormHelperText disabled={!error}>{error && errorMessage}</FormHelperText>
    </FormControl>
  );
};

export default SingleCheckboxCst;
